import { useTheme } from "@mui/joy/styles";
import { Button, Option, Select, Sheet, Typography } from "@mui/joy";
import NavItem from "./NavItem";
import { useLocation } from "react-router-dom";
import React from "react";
import { useRole } from "./Contexts/RoleContext";

export interface NavItemDisplay {
	Display: string;
	Route?: string;
	ChildItems?: Array<NavItemDisplay>;
}

export default function NavMenu() {
	const [loc, setLoc] = React.useState(useLocation());
	const location = useLocation();
	const { effectiveRole, emulatedRole, setEmulatedRole, isActuallyAdmin } = useRole();

	React.useEffect(() => {
		setLoc(location);
	}, [location]);

	const getNavigation = () => {
		const all = [
			{
				Display: "Tickets", //comment to force wrap in vscode
				ChildItems: [
					{ Display: "All Tickets", Route: "/alltickets" },
					{ Display: "Recommendation", Route: "/recommendations" },
					{ Display: "Sales Tickets", Route: "/sales" },
					{ Display: "Out of Service", Route: "/outofservice" },
				],
			},
			{ Display: "Buildings", Route: "/buildingportal" },
			// { Display: "Checked In Mechanics", Route: "/checkedin" },
			{
				Display: "Inspections",
				ChildItems: [
					{ Display: "Annual", Route: "/1year" },
					{ Display: "5 Year", Route: "/5year" },
					{ Display: "Alterations", Route: "/alterations" },
					// { Display: "Company Setup", Route: "/companies" },
				],
			},
			{ Display: "Follow Ups", Route: "/followups" },
			{
				Display: "Work Orders",
				ChildItems: [
					{ Display: "Pending", Route: "/uaplists" },
					{ Display: "Assigned", Route: "/aplists" },
					{ Display: "Finished", Route: "/finishedlists" },
				],
			},
			{
				Display: "Reports",
				ChildItems: [
					{ Display: "Broken Elevators", Route: "/brokenelevators" },
					{ Display: "Out of Service Elevators", Route: "/outofserviceelevators" },
					{ Display: "Missing Annual Inspections", Route: "/missingannualinspections" },
				],
			},
			{ Display: "Users", Route: "/users" },
			{ Display: "Elevator Ads", Route: "/elevatorads" },
			{ Display: "Proposals Missing Building", Route: "/proposalsmissingbuilding"},
			{ Display: "Proposals Missing Elevator", Route: "/proposalsmissingelevator"}
		] as Array<NavItemDisplay>;

		const adminOnly = [
			{ Display: "RingCentral", Route: "/ringcentral" },
			{ Display: "QBO Sync", Route: "/qbosync" }
		] as Array<NavItemDisplay>;

		const user = [
			{ Display: "Buildings", Route: "/buildingportal" },
		] as Array<NavItemDisplay>;

		// Use effectiveRole to determine navigation (respects client mode toggle)
		// Both Admin and Manager get full navigation; RingCentral is Admin-only
		if (effectiveRole === "Admin" || effectiveRole === "Manager") {
			const nav = [...all];
			if (isActuallyAdmin()) nav.push(...adminOnly.filter((x) => !nav.some((n) => n.Route === x.Route)));
			return nav;
		}
		return user;
	};

	const theme = useTheme() as any;

	return (
		<div style={{ flexBasis: "220px", height: "100%", backgroundColor: theme.palette.background.navMenu, display: "flex", flexDirection: "column" }}>
			<Sheet
				sx={{
					px: 2,
					py: 1,
					textAlign: "center",
					backgroundColor: theme.palette.background.navMenu,
				}}>
				<Typography level="body-sm" fontWeight={600} sx={{ color: theme.palette.background.level2 }}>
					Dynamic Elevator Control Corp.
				</Typography>
			</Sheet>
			{getNavigation().map((x) => {
				return <NavItem item={x} selected={x.Route ? loc.pathname === (x.Route as String) : x.ChildItems?.some((x) => loc.pathname === (x.Route as string)) ?? false} />;
			})}
			{/* Bottom section - anchored to bottom of nav panel */}
			<div style={{ marginTop: "auto" }}>
				{/* Role emulation selector — only visible to real Admins */}
				{isActuallyAdmin() && (
					<Select
						size="sm"
						value={emulatedRole ?? ""}
						placeholder="Emulate role..."
						onChange={(_, value) => setEmulatedRole(value === "" ? null : value)}
						color={emulatedRole ? "warning" : "neutral"}
						variant="soft"
						sx={{ mx: 1, mb: 1, fontSize: "0.75rem" }}>
						<Option value="">My Role (Admin)</Option>
						<Option value="Manager">Emulate: Manager</Option>
						<Option value="Client">Emulate: Client</Option>
						<Option value="Ticketing">Emulate: Ticketing</Option>
					</Select>
				)}
				<NavItem item={{ Display: "Logout", Route: "/logout" }} selected={false} />
			</div>
		</div>
	);
}
